import Script from 'next/script';
import { useSiteInfo } from '~/pages/_shared';
import { useLoggedInUser } from '~/pages/_shared/useLoggedInUser';

export const Pendo = () => {
   const { data: loggedInUser } = useLoggedInUser();
   const { data: siteInfo } = useSiteInfo();

   // Don't load Pendo if there is no logged in user.
   if (!loggedInUser) {
      return null;
   }

   // Check for a Pendo application key.
   if (!siteInfo?.pendo?.['application-key']) {
      return null;
   }

   return (
      <Script strategy="afterInteractive" id="pendo">
         {`
            (function(apiKey){
               (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
               v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                  y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
                  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

                  // Please use Strings, Numbers, or Bools for value types.
                  pendo.initialize({
                        visitor: {
                           id: "${loggedInUser.uid_v2}",

                           // You can add any additional visitor level key-values here,
                           // as long as it's not one of the reserved names.
                           job_title: "${siteInfo.pendo.job_title}",
                           department: "${siteInfo.pendo.department}",
                           location: "${siteInfo.pendo.location}",
                           shift: "${siteInfo.pendo.shift}",
                           privilege: "${siteInfo.pendo.privilege}",
                           date_created: "${siteInfo.pendo.date_created}",
                           last_login: "${siteInfo.pendo.last_login}",
                        },

                        account: {
                           id: "${siteInfo.domain}",

                           // You can add any additional account level key-values here,
                           // as long as it's not one of the reserved names.
                           environment: "${siteInfo.pendo.environment}",
                           uid: "${siteInfo.uid_v2}",
                           deployment_type: "${siteInfo.pendo.deployment_type}",
                           customer_type: "${siteInfo.pendo.customer_type}",
                           salesforce_id: "${siteInfo.pendo.salesforce_id}",
                           quarterly_version_number: "${siteInfo.quarterly_version_number ?? ''}"
                        }
                  });
            })("${siteInfo.pendo['application-key']}");
         `}
      </Script>
   );
};
